import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { Account } from './auth.models';

export interface LoginApiResponse {
  email: string;
  accounts: Account[];
}

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  constructor(private readonly http: HttpClient) {}

  login(email: string, password: string): Promise<LoginApiResponse> {
    return firstValueFrom(
      this.http.post<LoginApiResponse>('/api/auth/login', { email, password })
    );
  }
}
